import React from "react";
import { Link } from "react-router-dom";

// layout
import { Footer } from "../../../layout/Footer";

// icons
import { CircleUserRound, Notebook, ScrollText } from "lucide-react";

const LandingFooter = () => {
  return (
    <Footer
      className="app-footer fixed-bottom"
      size="md"
      start={<div className="w-33 d-flex flex-column align-items-center"></div>}
      center={
        <div className="w-33 d-flex flex-column align-items-center">
          <Link key="list" to="/tale/list" aria-label="List of Tales">
            <ScrollText size={32} />
          </Link>
        </div>
      }
      end={
        <div className="w-33 d-flex flex-column align-items-center">
          <CircleUserRound size={32} />
        </div>
      }
    />
  );
};

export default LandingFooter;
